import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = Pick<QueryComposableParams<never, unknown>, 'options'>

const fetchDefaultTemplates = async () => {
  const { data } = await apiClient.v3.kakaoDefaultTemplateFindElHandler();
  return checkApiResponse(data);
}

export const reservationGroupDefaultTemplateKeys = {
  all: [QUERY_KEY.kakaoDefaultTemplateFindElHandler] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(reservationGroupDefaultTemplatesQueryOptions())` */
export const reservationGroupDefaultTemplatesQueryOptions = () => ({
  queryKey: reservationGroupDefaultTemplateKeys.all,
  queryFn: () => fetchDefaultTemplates(),
})

export const useReservationGroupDefaultTemplatesQuery = ({ options }: QueryParams = {}) => {
  return useQuery(() => ({
    queryKey: reservationGroupDefaultTemplateKeys.all,
    queryFn: () => fetchDefaultTemplates(),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
